export default __webpack_public_path__ + "static/hopfen_01-6d64e2832f547324344e52fdede52605.png";